import { component } from 'picoapp';
import Drawer from 'utils/drawer';
import { setCookie } from 'utils/cookie';
import { handleizeString } from 'utils/string';
import { scrollLock } from 'utils/node';
import { image as renderImage } from 'utils/image';

/* eslint-disable */
export default component((node, ctx) => {
  /**
   * Step handler
   */

  class Steps {
    constructor(node) {
      // Init drawer
      this.drawer = Drawer(node, node.parentNode);

      this.drawer.on('opened', () => scrollLock());
      this.drawer.on('closed', () => scrollLock(false));

      // Settings
      this.currentStep = 1;
      this.recommended = {};
      this.options = [];

      this.arkkSizeButtons = node.querySelector('[data-arkk-shoes]');

      // Selectors
      // this.overlay = document.querySelector('[data-overlay]');
      this.isCart = document.body.classList.contains('template-cart');
      this.form = node.querySelector('[data-form]');
      this.submit = this.form.querySelector('[type="submit"]');
      this.genderButtons = node.querySelectorAll('[data-gender]');
      this.sizeInputs = node.querySelectorAll('input[name="size"]');
      this.steps = [...node.querySelectorAll('[data-content]')];
      this.close = node.querySelectorAll('[data-close]');

      this.sizeSchemas = window.sizeSchemas;
      this.productData = document.querySelector('.js-data');
      this.productJson = this.productData ? JSON.parse(this.productData.innerHTML) : null;

      this.sizes = {
        men: this.sizeSchemas[0].blocks.filter((block) => block.men),
        women: this.sizeSchemas[0].blocks.filter((block) => !block.men),
      };

      // Methods
      this.init();
      this.populateArkkButtons();
      this.formSubmit();

      document.addEventListener('click', (e) => {
        if (e.target.hash === '#sizeguide') {
          this.openSizeGuide();
        }
      });

      if (window.location.hash === '#sizeguide') {
        this.openSizeGuide();
      }

      this.close.forEach((close) => {
        close.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeSizeGuide();
        });
      });
    }

    /**
    * Init sizeguide
    */

    init() {
      const self = this;

      this.form.addEventListener('change', (e) => {
        const data = new FormData(self.form);

        for (const [name, value] of data.entries()) {
          this.options[name] = value;
        }

        // Trigger when changes made in form
        this.setActiveStep(e.target);
        this.setActiveSizes();
        this.sizeHandler();
      });
    }

    populateArkkButtons() {
      const shoes = window.productTypes[0].styles;

      for (const shoe of shoes) {
        if (shoe.image.src == null) continue;
        const name = shoe.type;

        this.arkkSizeButtons.innerHTML += `
          <label class="flex flex-col items-center w-[30%] lg:w-[20%]" for="${handleizeString(name)}">
            <input class="peer" id="${handleizeString(name)}" type="radio" name="arkk" value="${shoe.arkk_type_size}" disabled data-nextstep="3" data-type="${name}">
            ${renderImage(shoe.image, 'mb-3 max-h-16 object-contain scale-90 peer-checked:scale-100 transition-transform duration-200')}
            <p class="text-sm mt-auto peer-checked:font-bold">${name}<p>
          </label>
        `;
      }
    }

    // Handle sumit, and set cookie of suggested type
    formSubmit() {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        const cookieName = `sizeassistant-${this.recommended.gender}`;
        setCookie(cookieName, JSON.stringify(this.recommended), 360);
        this.closeSizeGuide();

        ctx.emit('sizeChosen', { recommended: this.recommended });
      });
    }

    setActiveStep(item = null, element = false) {
      const fixedStep = item ? item.dataset?.nextstep : null;
      const step = fixedStep ?? Object.keys(this.options).length + 1;
      this.currentStep = step;

      const nextStep = node.querySelector(`[data-step="${this.currentStep}"]`);
      if (nextStep) {
        nextStep.classList.remove('hidden');
        nextStep.classList.add('active');

        const inputs = nextStep.querySelectorAll('input');
        inputs.forEach((input) => input.disabled = false);
      }

      this.setActiveSubSteps(item);

      // Preselct value
      if (element) this.form.querySelector(`input[value="${element}"]`).checked = true;

      // Remove all preselcted inputs
      if (item && item.name !== 'size') {
        delete this.options.size;
        this.sizeInputs.forEach((input) => input.checked = false);
      }
    }

    // Collect all sub steps related to current step and hide
    setActiveSubSteps(item) {
      const parentStepElement = item ? item.closest('[data-step]') : null;

      // Bail early
      if (!parentStepElement) return;

      // Find related substeps in same group
      const subSteps = [...parentStepElement.querySelectorAll('[data-nextstep]')]
        .map((el) => el.dataset.nextstep)
        .filter((i) => i != this.currentStep && i.includes('.'));

      subSteps.forEach((el) => {
        const [, sub] = item.dataset.nextstep.split('.');

        // Bail if no sub steps
        if (!sub) {
          const domEl = node.querySelector(`[data-step="${el}"]`);
          if (domEl) domEl.classList.add('hidden');

          domEl.querySelectorAll('input').forEach((input) => input.checked = false);
          delete this.options.arkk;
        } else {
          const domEl = node.querySelector(`[data-step="${item.dataset.nextstep}"]`);
          if (domEl) domEl.classList.remove('hidden');
        }
      });
    }

    setActiveSizes() {
      const { gender, brand, country } = this.options;

      if (gender) {
        const respectiveGender = [...this.genderButtons].filter((item) => item.dataset.gender === gender);
        this.genderButtons.forEach((item) => item.classList.add('hidden'));
        respectiveGender[0].classList.remove('hidden');

        if (brand && country) {
          const sizes = respectiveGender[0].children;
          const respectiveSizes = [...sizes].filter((item) => item.dataset.brand === brand && item.dataset.country === country);

          [...sizes].forEach((item) => item.classList.add('hidden'));
          respectiveSizes.forEach((item) => item.classList.remove('hidden'));
        }
      }
    }

    sizeHandler() {
      const {
        gender,
        brand,
        country,
        arkk,
        size,
      } = this.options;

      if (!size) {
        this.submit.disabled = true;
        return;
      }

      // Prepare
      this.recommended = {};

      const selectedSize = this.sizes[gender].find((block) => block[`${brand}_size_${country}`] == size).arkk_size_eu;
      const selectedArkk = this.arkkSizeButtons.querySelector('input:checked');

      if (selectedArkk) {
        const arkkType = selectedArkk.dataset.type;

        // Merge with existing props
        Object.assign(this.recommended, {
          arkk: Number(arkk),
          arkkType,
        });
      }

      // Merge with existing props
      Object.assign(this.recommended, {
        size: selectedSize,
        gender,
      });

      this.submit.disabled = false;
    }

    openSizeGuide(type, gender) {
      this.drawer.open();

      if (type) {
        this.type = type;
        delete this.options.size;
        this.sizeInputs.forEach((input) => input.checked = false);
        this.submit.disabled = true;
      }

      if (gender) {
        this.gender = this.options.gender = gender;
        this.setActiveStep(false, gender);
      }
    }

    closeSizeGuide() {
      this.drawer.close();

      this.type = '';
      this.gender = '';
      delete this.options.gender;
      this.setActiveStep();
    }
  }

  const handleSteps = new Steps(node);
  window.sizeGuide = handleSteps;
});
